/**
 * ═══════════════════════════════════════════════════════════════════════════
 *  CLAIMS LAW — READ BEFORE EDITING THIS FILE
 *
 *  A value may only ever enter this object from a VERIFIED App Store figure,
 *  pulled from App Store Connect and checked at the time it is entered.
 *
 *  Fabricating a rating, a rating count, or a review — including as a
 *  placeholder, as lorem, as a design stand-in, or as "we'll swap it before
 *  launch" — violates this project's claims law. Placeholder social proof has
 *  a way of shipping.
 *
 *  There is no fabricated-data path in the renderer, and there must never be
 *  one. If the data is not here, the section renders the founders' own
 *  attestation and nothing else, which is honest and still converts.
 * ═══════════════════════════════════════════════════════════════════════════
 */

export const APP_STORE_PROOF = {
  rating: null, // number, one decimal, e.g. 4.8
  ratingCount: null, // integer, e.g. 214
  reviews: [], // [{ quote, author, rating }] — real, approved, attributed
};

/**
 * A rating may never render without its count beside it: a bare "4.8" hides
 * whether it came from six people or six thousand.
 */
export function hasRating(proof = APP_STORE_PROOF) {
  return (
    typeof proof.rating === 'number' &&
    typeof proof.ratingCount === 'number' &&
    proof.ratingCount > 0
  );
}

/** One review is an anecdote and looks worse than none. Two is the floor. */
export function hasReviews(proof = APP_STORE_PROOF) {
  return Array.isArray(proof.reviews) && proof.reviews.length >= 2;
}
